import { useClient } from 'hooks/useClient';
import { CINCELClient } from '@cincel/client';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useQuery } from 'react-query';

const fetchPrivateKeyService = async (client: CINCELClient, email) => {
  return client.fetchPrivateKeyByUser(email);
};

export const useFetchPrivateKey = ({ email, token, enabled = true }) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(token),
  });

  const resolvedToken = resolveTokenV3(token);

  const {
    data: privateKey,
    status: privateKeyStatus,
    isLoading: isPrivateKeyLoading,
    refetch: refetchPrivateKey,
    isError: isPrivateKeyError,
    error: privateKeyError,
    ...rest
  } = useQuery(
    ['privateKey', email, resolvedToken],
    () => fetchPrivateKeyService(client, email),
    {
      enabled: Boolean(enabled && email && resolvedToken),
      refetchOnWindowFocus: false,
    },
  );

  return {
    privateKey,
    privateKeyStatus,
    isPrivateKeyLoading,
    refetchPrivateKey,
    isPrivateKeyError,
    privateKeyError,
    ...rest,
  };
};
